<template>
    <v-row>
        <v-col>
            <v-text-field label="학교" v-model="inputData.affiliation" v-bind="inputProps" />
        </v-col>
        <v-col>
            <v-text-field label="학과" v-model="inputData.department" v-bind="inputProps" />
        </v-col>
    </v-row>
</template>

<script>
const inputProps = {
    outlined: true,
    dense: true,
    "hide-details": true,
    persistentPlaceholder: true,
    class: "rounded-0",
};

export default {
    props: ["value"],
    data() {
        return {
            inputData: {
                affiliation: null,
                department: null,
            },
            inputProps,
        };
    },
    methods: {
        init() {
            const { affiliation, department } = this.value;
            this.inputData.affiliation = affiliation;
            this.inputData.department = department;
        },
        sync() {
            const { affiliation, department } = this.inputData;
            this.$emit("input", { ...this.value, affiliation, department });
        },
    },
    mounted() {
        if (this.value?.affiliation) this.init();
    },
    watch: {
        "value.affiliation"() {
            if (this.value.affiliation !== this.inputData.affiliation) this.init();
        },
        "value.department"() {
            if (this.value.department !== this.inputData.department) this.init();
        },
        "inputData.affiliation"() {
            if (this.value.affiliation !== this.inputData.affiliation) this.sync();
        },
        "inputData.department"() {
            if (this.value.department !== this.inputData.department) this.sync();
        },
    },
};
</script>

<style></style>
